angular.module('unica_relator.relator_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// RELATOR
		.state('app.relator', {
			url: '/relator',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/relator/templates/relator.html',
					controller: 'RelatorBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// RELATOR LIST AND DELETE
			.state('app.relator.list', {
				url: '/list',
				views: {
					'relatorContent': {
						templateUrl: './modules/relator/templates/list.html',
						controller: 'RelatorListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Relatori'
				}
			})

			// RELATOR CREATE
			.state('app.relator.create', {
				url: '/create',
				views: {
					'relatorContent': {
						templateUrl: './modules/relator/templates/create.html',
						controller: 'RelatorCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Aggiungi Relatore',
					parent: 'app.relator.list'
				}
			})

			// RELATOR EDIT
			.state('app.relator.edit', {
				url: '/edit/:id',
				views: {
					'relatorContent': {
						templateUrl: './modules/relator/templates/edit.html',
						controller: 'RelatorEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Relatore',
					parent: 'app.relator.list'
				}
			});


});

